import React, { useState } from "react";
import { Col, Collapse, Divider, Row, Table } from "antd";
import { HospiceOrganizationWithDetailsResponse } from "../../models/OrganizationModels";
import RoundedButton from "../RoundedButton";
import { useNavigate } from "react-router-dom";
import "../../styles/_orgs.scss"
import PlusButton from "../PlusButton";
import StatusIndicator from "./StatusIndicator";
import OrganizationHeader from "./OrganizationHeader";

const { Panel } = Collapse;

type Props = {
    organization: HospiceOrganizationWithDetailsResponse;
};

const OrganizationView: React.FC<Props> = ({ organization }) => {
    const activeKey = "1"; // keeps collapsable opened

    return (
        <div>
            <OrganizationHeader headerText={`Organization: ${organization.hospiceName}`} className="bg-collapse-light-blue p-3 border mb-4" />
            <Row className="border border-dark-subtle mb-2">
                <Col span={5} className="p-3 fs-7 bg-grey" >Organization Code</Col>
                <Col span={5} className="p-3 fs-7 bg-white" >{organization.hospiceRefId}</Col>
            </Row>
        </div>
    );
};

export default OrganizationView;
